import React, { useState } from 'react';
import { HiOutlineMinusCircle } from 'react-icons/hi';
import { MdAddCircleOutline } from 'react-icons/md';

function FAQCard({ question, answer }) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div 
      className={`group transition-all duration-300 border-2 rounded-2xl mb-4 overflow-hidden ${
        isOpen 
        ? 'border-blue-400 bg-blue-50/30 shadow-md' 
        : 'border-gray-100 bg-white hover:border-blue-200'
      }`}
    >
      <button
        className="w-full flex items-center justify-between px-6 py-5 text-left transition-colors"
        onClick={() => setIsOpen(!isOpen)}
        aria-expanded={isOpen}
      >
        <span className={`font-bold text-base sm:text-lg transition-colors duration-300 ${
          isOpen ? 'text-blue-700' : 'text-gray-800'
        }`}>
          {question}
        </span>
        
        <div className="flex-shrink-0 ml-4 transition-transform duration-300 transform">
          {isOpen ? (
            <HiOutlineMinusCircle size={28} className="text-blue-600 animate-in fade-in zoom-in duration-300" />
          ) : (
            <MdAddCircleOutline size={28} className="text-gray-400 group-hover:text-blue-500" />
          )}
        </div>
      </button>

      {/* Animated Content Container */}
      <div 
        className={`grid transition-all duration-300 ease-in-out ${
          isOpen ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'
        }`}
      >
        <div className="overflow-hidden">
          <div className="px-6 pb-6 text-sm sm:text-base text-gray-600 leading-relaxed border-t border-blue-100/50 pt-4 mt-0">
            {answer}
          </div>
        </div>
      </div>
    </div>
  );
}

export default FAQCard;